import React from 'react';
import {  Link } from 'react-router-dom';


const Footer = () => {
  return (
  
    <div>   



<section id="footer" class="p-3 mt-1 text-black" style={{background: "#f4f4f4"}}>
  <div class="container-fluid" style={{ padding: 25 }}>
    <div class="row">
      
      <div class="col-md-6">
        <div class="footer-logo">
          <img 
  src="./assets/img/DFA.svg" 
  alt="datafluent" 
  className="logo" 
  style={{ maxWidth: '120px' }} 
/>

          <p className='mt-3'>DataFluent Analytics. A Software and Analytics Company.</p>
        </div>
        <div className="row footer-address">
  <div className="col-md-6">
    <p>
      <strong>Bangladesh</strong><br />
      Islam Tower, Level 6, <br /> 464/H DIT Road, Rampura, Dhaka
    </p>
    <p>
      <i className="fas fa-phone-alt"></i> +88 02-55128812<br />
      <i className="fas fa-envelope"></i> <a href="mailto:info@bangladesh.com">dfaadmin@datafluent.xyz</a>
    </p>
  </div>

  <div className="col-md-6">
    <p>
      <strong>Australia</strong><br />
      1015A Botany Road, Mascot<br /> NSW 2020, Australia
    </p>
    <p>
      <i className="fas fa-phone-alt"></i> +61 400 810 105<br />
      <i className="fas fa-envelope"></i> <a href="mailto:info@australia.com">dfaadmin@datafluent.xyz</a>
    </p>
  </div>
</div>

      </div>

      
      <div class="col-md-3 mt-6">
        <h5>Useful Links</h5>
        <div class="">
          <ul>
          <li><Link to="/software-development">Software Development</Link></li> 
          <li><Link to="/data-engineering">Data Engineering</Link></li>
          <li><Link to="/data-analytics">Data Analytics</Link></li>
          <li><Link to="/artificial-intelligence">Artificial Intelligence</Link></li>
          <li><Link to="/it-support">IT Support</Link></li>
          <li><Link to="/business-intelligence">Business Intelligence</Link></li>
          <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
          </ul>
        </div>
      </div>

      
      <div className="col-md-3 mt-6">
  <h5>Membership</h5>
  <div className="logo-section mt-3">
    <img
      src="./assets/img/basis.svg"
      alt="Data Fluent Logo"
      style={{
        maxWidth: '120px',
        display: 'block',
        margin: '10px 0' // Aligns the logo to the left
      }}
    />
  </div>
</div>


    </div>
  </div>
</section>



<section id="footer_b" class="pt-3 pb-3  bg-dark ">
<div class="container-xl">
  <div class="footer_b1 row text-center">
   <div class="col-md-12">
       <p class="mb-0 text-white-50">© 2025 DataFluent Analytics. All Rights Reserved | Design by <a class="text-white fw-bold" href="https://www.datafluent.xyz/">DataFluent Analytics</a></p>
   </div>
  </div>
</div>

</section>
</div>


  );
};

export default Footer;
